import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AvailableTimeSelect = ({ date, value, onChange, testId = 'available-time', className = '' }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) {
      setSlots([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    axios.get(`${API}/availability/slots/${date}`)
      .then(({ data }) => {
        if (cancelled) return;
        const free = (data.slots || []).filter(s => s.available).map(s => s.time);
        setSlots(free);
        if (value && !free.includes(value)) onChange('');
      })
      .catch(() => { if (!cancelled) setSlots([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const placeholder = !date
    ? 'Elija primero una fecha'
    : loading
      ? 'Cargando horarios…'
      : slots.length === 0
        ? 'Sin horarios disponibles'
        : 'Seleccionar hora';
  const noSlots = date && !loading && slots.length === 0;

  return (
    <div>
    <Select value={value || ''} onValueChange={onChange} disabled={!date || loading || slots.length === 0}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-64">
        {slots.map((time) => (
          <SelectItem key={time} value={time} data-testid={`${testId}-option-${time.replace(':', '')}`}>{time}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    {noSlots && (
      <p className="text-xs text-amber-600 mt-1" data-testid={`${testId}-empty`}>
        No hay horarios disponibles para esta fecha. Elija otra fecha
      </p>
    )}
    </div>
  );
};
